import { VI_LANG } from "constants/global";
import Swal from 'sweetalert2';

const getMessage403 = (local) => {
    if (local === VI_LANG) {
        Swal.fire({
            title: "Thất bại",
            text: "Bạn không có quyền",
            icon: "error",
            dangerMode: false
        });
    } else {
        Swal.fire({
            title: "Fail",
            text: "You don't have permission",
            icon: "error",
            dangerMode: false
        });
    }
}
export default getMessage403
